import { z } from 'zod';

// Helper function to validate domain parts
const isValidDomainParts = (parts) => {
    if (parts.length < 2)
        return false;
    // Check no empty parts and no hyphens at start/end
    for (const part of parts) {
        if (part.length === 0 || part.startsWith('-') || part.endsWith('-')) {
            return false;
        }
    }
    // Last part must be valid TLD (letters only, 2+ chars)
    const tld = parts[parts.length - 1];
    return /^[a-zA-Z]{2,}$/.test(tld);
};
// URL validation schema - accepts domains with or without protocol
const urlSchema = z
    .string()
    .min(1, 'Website URL is required')
    .refine((value) => {
    if (!value)
        return false;
    const trimmedValue = value.trim();
    // If it already has a protocol, validate as-is (only http/https allowed)
    if (trimmedValue.includes('://')) {
        if (!trimmedValue.startsWith('http://') && !trimmedValue.startsWith('https://')) {
            return false;
        }
        try {
            const url = new URL(trimmedValue);
            if (!url.hostname || url.hostname === 'localhost') {
                return false;
            }
            return isValidDomainParts(url.hostname.split('.'));
        }
        catch {
            return false;
        }
    }
    // For domains without protocol, validate domain format first
    const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    if (!domainRegex.test(trimmedValue)) {
        return false;
    }
    return isValidDomainParts(trimmedValue.split('.'));
}, { message: 'Enter a valid website URL' })
    .transform((value) => {
    if (!value)
        return value;
    const trimmedValue = value.trim();
    // If it already has a protocol, return as-is (but only if valid)
    if (trimmedValue.includes('://')) {
        if (trimmedValue.startsWith('http://') || trimmedValue.startsWith('https://')) {
            return trimmedValue;
        }
        return trimmedValue;
    }
    // Add https:// prefix for domains without protocol
    return `https://${trimmedValue}`;
});

export { urlSchema };
//# sourceMappingURL=url.js.map
